import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  async submit(event) {
    event.preventDefault()
    const form = event.target
    const formData = new FormData(form)
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    
    try {
      const response = await fetch(form.action, {
        method: "POST",
        body: formData,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Accept": "application/json",
          "X-CSRF-Token": csrfToken
        }
      })

      const data = await response.json()

      if (response.ok) {
        this.showNotification(data.message, "success")
        form.reset()
      } else {
        this.showNotification(data.message, "error")
      }
    } catch (error) {
      this.showNotification("Произошла ошибка при отправке", "error")
    }
  }

  showNotification(message, type) {
    const notification = document.createElement("div")
    
    const bgColor = type === "success" ? "#10b981" : "#ef4444"
    notification.style.cssText = `
      position: fixed;
      top: 2rem;
      right: 2rem;
      padding: 1rem 1.5rem;
      background-color: ${bgColor};
      color: white;
      border-radius: 0.5rem;
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
      z-index: 9999;
      font-size: 16px;
      font-weight: 500;
      transition: opacity 0.3s, transform 0.3s;
    `
    notification.textContent = message

    document.body.appendChild(notification)

    setTimeout(() => {
      notification.style.opacity = '0'
      notification.style.transform = 'translateX(1rem)'
    }, 3000)

    setTimeout(() => {
      notification.remove()
    }, 3500)
  }
}
